import strings from 'strings';

export const COPIES = strings.sendoutsV2.form.sections.sendoverReasons;

export const FORM_FIELDS_MAP = {
  SendoverReasons: {
    key: 'sendoverReasons'
  },
  SendoverReasonsGuard: {
    key: 'sendoverReasonsGuard'
  },
  Comments: {
    key: 'comments'
  }
};
